import type { ReactNode } from "react";

import type { DeviceDetail } from "@busright/data-contract";

// Identity header facts for a device. Pure presentation of the contract's hardware/OS fields — no
// derived or fabricated values. Missing fields render an explicit em-dash.

const dash = (value: string | null): string => (value && value.length > 0 ? value : "—");

interface Fact {
  readonly label: string;
  readonly value: string;
  readonly mono?: boolean;
}

export interface DevFactsProps {
  readonly device: DeviceDetail;
}

export const DevFacts = ({ device }: DevFactsProps): ReactNode => {
  const facts: readonly Fact[] = [
    { label: "Serial", value: dash(device.serial), mono: true },
    { label: "Model", value: dash(device.hwModel) },
    { label: "OS version", value: dash(device.osVersion), mono: true },
    { label: "IMEI", value: dash(device.imei1), mono: true },
    { label: "Security state", value: dash(device.securityState) },
    { label: "Carrier", value: dash(device.cellularCarrier) },
  ];

  return (
    <div className="grid cols-3" style={{ gap: 12 }}>
      {facts.map((fact) => (
        <div key={fact.label}>
          <div style={{ fontSize: 11, color: "var(--br-text-muted)" }}>{fact.label}</div>
          <div
            className={fact.mono ? "mono" : undefined}
            style={{ fontSize: 14, color: "var(--br-text-primary)", marginTop: 2 }}
          >
            {fact.value}
          </div>
        </div>
      ))}
    </div>
  );
};
